module.exports = __webpack_public_path__ + "static/Ranger 3-e9867692d5ec9a1a4c6d2c2595154833.jpg";